var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.371 9.72L5 6.35 1.629 9.72a.951.951 0 01-1.35 0 .956.956 0 010-1.349L3.652 5 .279 1.628A.954.954 0 111.63.279L5 3.651 8.371.279a.951.951 0 011.35 0 .953.953 0 010 1.349L6.349 5 9.721 8.37a.952.952 0 010 1.35.954.954 0 01-1.35 0z",
    fill: "#A6A6A6"
  })));
}
export default SvgOnboardingClose;